import React from 'react';

export default function SectionDivider() {
  return (
    <div className="w-full flex justify-center my-12">
      <div className="relative w-2/3 h-[2px] overflow-hidden bg-gray-700">
        <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-teal-400 to-transparent animate-slide" />
      </div>
    </div>
  );
}